import { render } from "./Mails.vue?vue&type=template&id=dce24464"
import script from "./Mails.vue?vue&type=script&lang=js"
export * from "./Mails.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/newsletter.norden.org/releases/74710130/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__